import numeral from 'numeral'

export function amount(value: string | number, formater = '0,[0]'): string {
  return value ? numeral(value).format(formater) : '-'
}
